import { Modal } from "ui/base/modal/Modal"
import { fonts, mediaSizes, themeColor } from "ui/theme"
import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import { LogoIcon } from "ui/icons"
import { ButtonPrimary } from "ui/base/Button/ButtonStyled"
import { routesPath } from "conts/routes"
import { BlueTicket } from "ui/icons/BlueTicket"
import {appRoute} from "../../../pages/app/app.routes";

export const WelcomeModal = ({ show, handleClose }) => {
    const navigate = useNavigate()

    const handleButton = () => {
        handleClose()
    }

    const handleBecomeInstructor = () => {
        navigate(appRoute.completeProfile.fullPath)
        handleClose()
    }

    return (
        <Modal show={show} handleClose={handleClose} maxWidth={390}>
            <Container>
                <BlueTicket width={75} height={75} />
                <WelcomeTitle>{"Welcome!"}</WelcomeTitle>
                <Description>
                    We're excited to have you on board!<br />
                    Discover local classes, meet inspiring
                    instructors, and try something new.
                </Description>
                <ButtonPrimary onClick={handleButton} >
                    Back to page
                </ButtonPrimary>
                <ButtonPrimary variant='ghost'  onClick={handleBecomeInstructor} >
                    Continue to sign-up as an instructor
                </ButtonPrimary>
            </Container>
        </Modal>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 1rem;

    & > svg {
        width: 70px;
        height: 70px;
        display: none;
    }

    @media (width >= ${mediaSizes.lg}) {
        & > svg {
            width: 70px;
            height: 70px;
            display: flex;
        }
    }
`

const WelcomeTitle = styled.h2`
  font-weight: 600;
  font-size: 26px;
  letter-spacing: 0%;
  text-align: center;
`

const Description = styled.p`
  width: 95%;
  font-weight: 400;
  font-size: 18px;
  line-height: 155%;
  letter-spacing: 0%;
  text-align: center;
`

const AlertWrap = styled.div`
  margin-bottom: 12px;
  padding: 20px;
  width: 45px;
  height: 45px;
  box-sizing: content-box;
  border-radius: 50%;
  background-color: #edf0ff;
`;
